import type { KasPricesheetItem } from "@/client";
import { columns } from "./columns";
import { DataTable } from "./data-table";

export function PricesheetTable({ data }: { data: KasPricesheetItem[] }) {
  return <DataTable columns={columns} data={data} />;
}
